import axios from 'axios'
import tokens from '@lacedltd/design-tokens/tokens'

const style = {
  base: {
    backgroundColor: 'transparent',
    color: tokens.color.airJordan.p,
    fontSize: tokens.fontSize[3],
    lineHeight: tokens.lineHeight.action,
    padding: tokens.spacing[5]
  },
  invalid: { color: tokens.color.airPresto[900] }
}

export const createStripeCardElement = (stripe) => {
  const elements = stripe.elements()

  return elements.create('card', { style })
}

export const createStripeIbanElement = (stripe) => {
  const elements = stripe.elements()

  return elements.create('iban', {
    style,
    supportedCountries: ['SEPA']
  })
}

export const createStripeToken = (stripe, type, data) => {
  return stripe.createToken(type, data).then((response) => {
    if (!('error' in response)) {
      return { id: response.token.id }
    }

    // Error codes here: https://stripe.com/docs/error-codes
    return { error: response.error.message, code: response.error.code }
  })
}

export const createStripeExternalAccount = async (token, localiseUrl) => {
  await axios
    .post(
      localiseUrl('/account/external_accounts', {
        localeAsParam: true
      }),
      {
        token
      }
    )
    .then((response) => {
      if (response.data.error && response.data.error.includes('currency')) {
        window.location = localiseUrl(
          `${window.location.origin}/account/external_accounts/new?error=${response.data.error}`
        )
      } else if (response.status === 200) {
        window.location = localiseUrl(
          `${window.location.origin}/account/external_accounts`
        )
      }
    })
    .catch((error) => {
      console.error(error)
    })
}
